import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { OAuthService } from 'angular-oauth2-oidc';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { AccountClient, LoginModelRequest, LoginModelResponse, RefClient } from 'src/app/services/api-client';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const GRAPH_ENDPOINT = '';
const Version = '2.0.4';
type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
};

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  myForm!: UntypedFormGroup;
  environment: any;
  version: any;
  userProfile: any;
  loginDisplay = false;
  isIframe = false;
  private readonly _destroying$ = new Subject<void>();
  profile!: ProfileType;
  isAuthenticated = false;

  constructor(private http: HttpClient, @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private msalService: MsalService, private msalBroadcastService: MsalBroadcastService,
    private oauthService: OAuthService, public authService: AuthService, private formBuilder: UntypedFormBuilder, private accountclient: AccountClient, private router: Router, private refClient: RefClient) { }

    ngOnInit(): void {
      this.environment = environment.environment;
      this.version = Version;
      this.isIframe = window !== window.parent && !window.opener;
  
      this.msalBroadcastService.msalSubject$
        .pipe(
          filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        ).subscribe((result: EventMessage) => {
          console.log(result);
          const content_ = JSON.stringify(result);
          const content = JSON.parse(content_);
          var email = content.payload.account.username;
          var token = content.payload.accessToken;
  
          localStorage.setItem('prspUserToken', token);
  
          this.AzureADGetProfile(email);
        });
  
      this.msalBroadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None),
          takeUntil(this._destroying$)
        )
        .subscribe(() => {
          this.AzureADSetLoginDisplay();
        })
  
      this.initForm();
    }

    initForm() {
      this.myForm = this.formBuilder.group({
        Username: ['', Validators.required],
        Password: ['', Validators.required]
      });
    }

  AzureADLogin() {
    var id = localStorage.getItem("prspUserId")!;
    if (id != null || id == "") {
      this.router.navigate(['/dashboard'])
        .then(() => {
          window.location.reload();
        });
    }
    else {
      if (this.msalGuardConfig.authRequest) {
        this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.msalService.loginRedirect();
      }
    }
  }

  AzureADLogOut() {
    localStorage.removeItem('prspUserId');
    localStorage.removeItem('prspUserEmail');
    localStorage.removeItem('prspUserName');

    if (environment.isCommercialization) {
      window.close();
    }
    else {
      this.msalService.logoutRedirect({
        postLogoutRedirectUri: environment.postLogoutRedirectUri
      });
    }
   
  }

  AzureADGetProfile(id: string) {
    this.refClient.getUserByEmail(id).pipe().subscribe((result) => {
      localStorage.setItem('prspUserId', result.id);
      localStorage.setItem('prspUserEmail', result.email);
      localStorage.setItem('prspUserName', result.firstName + " " + result.lastName);
      localStorage.setItem('prspUserTenant', result.tenantId);

      this.router.navigate(['/dashboard'])
        .then(() => {
          window.location.reload();
        });
    },
      error => {
        console.log(error.message);
      })
  }

  AzureADSetLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
    console.log(this.loginDisplay);
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
